import _isEmpty from 'lodash/isEmpty';
export default function useAnchor() {
  var hasWindowObj = typeof window !== 'undefined';
  if (!hasWindowObj) {
    return ['', false];
  }
  var hash = window.location.hash;
  if (_isEmpty(hash)) {
    return ['', true];
  }
  if (hash[0] === '#') {
    return [decodeURI(hash.substring(1)), true];
  }
  return [decodeURI(hash), true];
}